import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";

const IDLE_MS = 30 * 60 * 1000;
const KEY = "gamls_last_activity";
const EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "wheel"];

export const IdleWatcher = () => {
  const { auth, logout } = useApp();
  const nav = useNavigate();
  const out = useRef(null);
  out.current = async () => { await logout(); nav("/"); };
  const active = !!auth;
  useEffect(() => {
    if (!active) { return undefined; }
    let last = 0;
    const mark = () => {
      const now = Date.now();
      if (now - last > 5000) { last = now; localStorage.setItem(KEY, String(now)); }
    };
    localStorage.setItem(KEY, String(Date.now()));
    EVENTS.forEach((e) => window.addEventListener(e, mark, { passive: true }));
    const check = async () => {
      if (Date.now() - Number(localStorage.getItem(KEY) || 0) < IDLE_MS) return;
      await out.current();
      toast.info("You were signed out after 30 minutes of inactivity", { duration: 10000 });
    };
    const t = setInterval(check, 15000);
    document.addEventListener("visibilitychange", check);
    return () => {
      clearInterval(t);
      document.removeEventListener("visibilitychange", check);
      EVENTS.forEach((e) => window.removeEventListener(e, mark));
    };
  }, [active]);
  return null;
};
